const BASE = {

    "getRecommend":{//根据用户ID查询用户信息
        url:"system/public/getRecommend",
        method:"GET"
    },
    'getMenum': {//获取菜单
        url: "system/public/menu",
        method: "GET"
    },
    'getHomeNews': {//首页新闻
        url: "system/public/getHomeNews",
        method: "GET"
    },
    'getPicByModel': {//按类型查询图片
        url: "system/public/getPicByModel",
        method: "GET"
    },
    'addConsult': {//增加咨询
        url: "system/public/consult",
        method: "POST"
    },
    'getRiskData': {//查询risk数据
        url: "system/public/getRiskData",
        method: "GET"
    },
    'getContentDetailById': {//得到详情
        url: "system/public/getContentDetailById",
        method: "GET"
    },
    'getNewsList': {//得到新闻列表
        url: "system/public/getNewsList",
        method: "GET"
    },
    'getNewsDetail': {//得到新闻详情
        url: "system/public/getNewsDetail",
        method: "GET"
    },




}

export default BASE;
